import { usePatchedNavigate } from "src/Hooks/usePatchedNavigate";
import { useQuery } from "src/Hooks/useReactQuery";
import APP_ROUTES from "src/routes/routes";
import { getFilesDownloadSequencePackage } from "src/services/sequences";

const useGetFilesDownloadSequencePackage = (params) => {
  const { page = 1, limit = 9999999, q, data: sequenceList } = params || {};
  const navigate = usePatchedNavigate();

  const { data, isError, error, refetch, isFetching } = useQuery({
    queryKey: ["getFilesDownloadSequencePackage"],
    queryFn: () => {
      const params = sequenceList.map((item) => ({
        yamcs_package_increment_id: item.yamcs_package?.increment_id,
        test_package_input_id: item.test_package?.user_input_id,
        sequence_package_input_id: item.user_input_id,
      }));
      return getFilesDownloadSequencePackage(params);
    },
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (error?.response?.status === 404) {
        navigate(APP_ROUTES.NOT_FOUND);
      }
    },
  });

  return {
    data,
    refetch,
    isFetching,
    isError,
    error,
  };
};

export default useGetFilesDownloadSequencePackage;
